import { Button } from "@/components/Button";
import { validateEmail } from "@/utils";
import { UilTimes } from "@iconscout/react-unicons";
import { useMediaQuery } from "@react-hookz/web";
import { useState } from "react";

interface ModalProps {
  onClose: () => void;
  countryId: number;
  onSubmit: (email: string, countryId: number) => void;
}

const Modal = (props: ModalProps) => {
  const [phase, setPhase] = useState(1);
  const [isValid, setIsValid] = useState(true);
  const [inputText, setInputText] = useState("");

  const isMobileDevice = useMediaQuery("(max-device-width: 480px)");

  const height = isMobileDevice ? 75 : 100;
  const width = isMobileDevice ? 75 : 100;

  const handleChange = ({ currentTarget }) => {
    setIsValid(validateEmail(currentTarget.value));
    setInputText(currentTarget.value);
  };

  return (
    <div className="bg-white p-5 w-full max-w-[94%] md:max-w-[340px] md:text-center flex flex-col justify-center items-center absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2">
      <button
        onClick={props.onClose}
        className="absolute -right-3 -top-3 bg-white p-1 rounded-full text-gray-600 border border-gray-600"
      >
        <UilTimes size={16} />
      </button>
      {phase === 2 ? (
        <img src="/assets/images/done.gif" height={height} width={width} />
      ) : (
        <img src="/assets/images/sad.gif" height={height} width={width} />
      )}
      <p className="font-bold text-lg">
        {phase === 1
          ? "Sorry we do not support your country at the moment."
          : "Great! You will be notified when your country is available."}
      </p>
      {phase === 1 && (
        <input
          className={`${
            !isValid ? "border-red-500 text-red-500" : "focus:border-green"
          } w-full bg-gray-200 outline-none border transition-all duration-200 mt-3 px-2 py-3 placeholder:text-gray-500`}
          placeholder="Your email"
          value={inputText}
          onChange={handleChange}
        />
      )}
      {phase === 1 ? (
        <Button
          className="mt-5 w-full"
          onClick={() => {
            if (isValid) {
              setPhase(2);
              props.onSubmit(inputText, props.countryId);
            }
          }}
        >
          Notify when available
        </Button>
      ) : (
        <Button className="mt-10 w-full" onClick={props.onClose}>
          Close this dialog
        </Button>
      )}
    </div>
  );
};
Modal.defaultProps = {} as Partial<ModalProps>;

export default Modal;
